<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()

const navItems = [
  { label: '首页', to: '/' },
  { label: '下载', to: '/download' },
  { label: '隐私政策', to: '/privacy' },
]
</script>

<template>
  <header class="site-header">
    <RouterLink class="site-header__brand" to="/" aria-label="CIPOPO 首页">
      <img class="site-header__logo" src="/cipopo_logo.png" alt="CIPOPO" />
    </RouterLink>

    <nav class="site-header__nav" aria-label="主导航">
      <RouterLink
        v-for="item in navItems"
        :key="item.to"
        :to="item.to"
        class="site-header__link"
        :class="{ 'site-header__link--active': route.path === item.to }"
        :aria-current="route.path === item.to ? 'page' : undefined"
      >
        {{ item.label }}
      </RouterLink>
    </nav>
  </header>
</template>

<style scoped>
.site-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 72px;
  padding: 16px clamp(20px, 5vw, 48px);
  background: #000000;
}

.site-header__brand {
  display: inline-flex;
  flex-shrink: 0;
}

.site-header__logo {
  display: block;
  height: 28px;
  width: auto;
}

.site-header__nav {
  display: flex;
  align-items: center;
  gap: clamp(20px, 4vw, 40px);
}

.site-header__link {
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  line-height: 1;
  transition: color 0.2s ease;
}

.site-header__link:hover,
.site-header__link--active {
  color: #ffffff;
}

@media (max-width: 640px) {
  .site-header {
    min-height: 64px;
    padding-inline: 16px;
  }

  .site-header__logo {
    height: 24px;
  }

  .site-header__nav {
    gap: 16px;
  }

  .site-header__link {
    font-size: 13px;
  }
}
</style>
